//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
	data(){
		return {
			mytitle:''
		}
	},
	methods:{
		goback:function(){
			history.back()
		}
	},
	mounted(){
		this.mytitle = window.localStorage.getItem("name");
		
		
	}
}



// WEBPACK FOOTER //
// ./src/components/xtitle.vue